import { useSelector } from 'react-redux';
import type { RootState } from '../../store';
import { User, Phone, Mail, Shield, Smartphone } from 'lucide-react';
import { SurveillantLayout } from '../SurveillantLayout';

export default function ProfilSurveillant() {
  const user = useSelector((s: RootState) => s.auth.user);
  return (
    <SurveillantLayout title="Mon profil">
      <div className="space-y-3">
        <div className="bg-slate-900 border border-slate-800 rounded-xl p-4">
          <div className="flex items-center gap-3">
            <div className="w-14 h-14 rounded-full bg-blue-600/20 border border-blue-500/40 flex items-center justify-center">
              <User size={26} className="text-blue-400" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-bold text-white truncate">
                {user?.prenoms} {user?.nom}
              </div>
              <div className="text-xs text-slate-400 capitalize">{user?.role || '—'}</div>
            </div>
          </div>
          <div className="mt-3 space-y-1.5 text-sm">
            {user?.email && (
              <div className="flex items-center gap-2 text-slate-300">
                <Mail size={13} className="text-slate-500" /> {user.email}
              </div>
            )}
            {(user as any)?.telephone && (
              <div className="flex items-center gap-2 text-slate-300">
                <Phone size={13} className="text-slate-500" /> {(user as any).telephone}
              </div>
            )}
          </div>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-xl p-4">
          <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-slate-400 mb-2 font-semibold">
            <Smartphone size={12} /> Installer l'application
          </div>
          <p className="text-xs text-slate-300 leading-relaxed">
            Sur Android / Tablette : ouvre le menu de Chrome ou ton navigateur et choisis
            <strong> « Ajouter à l'écran d'accueil »</strong>.
          </p>
          <p className="text-xs text-slate-300 leading-relaxed mt-1.5">
            Sur iPhone / iPad : utilise Safari, appuie sur le bouton Partager puis
            <strong> « Sur l'écran d'accueil »</strong>.
          </p>
          <p className="text-xs text-slate-300 leading-relaxed mt-1.5">
            Sur ordinateur : Chrome propose une icône d'installation à droite de la barre
            d'adresse, ou via Menu &rarr; Installer.
          </p>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-xl p-4">
          <div className="flex items-center gap-2 text-xs uppercase tracking-wider text-slate-400 mb-2 font-semibold">
            <Shield size={12} /> Accès
          </div>
          <p className="text-xs text-slate-400">
            Tu fais partie de l'équipe surveillance / vie scolaire.
            Tes actions (présences, justifications, observations) sont tracées pour audit.
          </p>
        </div>
      </div>
    </SurveillantLayout>
  );
}
